jQuery(document).ready(function ($) {
  // var $checkbox = $('.cat-list input');
  var $select = $("#select-cat");
  var initialFilters = [];
  var flag = false;
  var updatedCategory = "";
  var count = 1;
  var getTag = localStorage.getItem('tag');

  if (getTag) {
    var convertTag = getTag.split('-').join(' ');
    $('.blog-wrap-title').text(convertTag);
  }

  if (window.location.pathname === '/blog/') {
    $(window).on('beforeunload', function(){
      $(window).scrollTop(0);
    });
  }
  
  localStorage.removeItem('tag');

  $("#select-cat option").each(function () {
    initialFilters.push($(this).val());
  });

  $select.change(function () {
    var category = $("#select-cat option:selected").val();

    if (category === "") {
      category = initialFilters;
      $("#more_posts").prop("disabled", false).css("opacity", "1");
      $("#more_posts").fadeOut();
    }

    $('.blog-wrap-title').text('THE LATEST');

    getTag = category;
    updatedCategory = category; 
    flag = true;

    updateFilterSort();
  });

  // UPDATE FILTER SORT
  function updateFilterSort(pageNumber = 1, isLoadMore) {
    $(".loading-overlay").removeClass("hide");

    var test = !getTag ? !flag ? initialFilters : updatedCategory : getTag;
    console.log(typeof test)

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "GET",
      data: {
        page: pageNumber,
        categories: !getTag ? !flag ? initialFilters : updatedCategory : getTag,
        action: "listFilteredBlogs",
      },
      success: function (data) {
        var blogData = JSON.parse(data);
        buildResults(blogData, isLoadMore);
        $(".loading-overlay").addClass("hide");

        if (count === $(".page-numbers button").length) {
          // $("#more_posts").prop("disabled", true);
          $("#more_posts").fadeOut();
        } else {
          $("#more_posts").fadeIn();
        }
      },
      error: function (err) {
        console.log(err);
      },
    });
  }

  // BUILD RESULTS FUNCTION
  function buildResults(results, isLoadMore) {
    if (!isLoadMore) {
      $(".inventory-listings-grid .cell:not([data-template])").remove();
    }

    var posts = results.posts,
        page = results.page_num,
        pages = results.num_pages;

    $("[data-num-result]").text(results.count);

    if (posts.length) {
      for (var i = 0; i < posts.length; i++) {
        var categories = posts[i].category;
        var $temp = $(
          ".inventory-listings-grid .cell.hide[data-template]"
        ).clone();

        if (categories) {
          for (var j = 0; j < categories.length; j++) {
            var catName = categories[j].name.replace(/&amp;/g, "&");
            var p = $("<p></p>").text(catName);
            $temp.find("[data-category]").append(p);
          }
        }

        $temp.find("[data-link]").attr("href", posts[i].product_url);
        if (posts[i].post_image) {
          $temp
            .find("[data-image-bg]")
            .css("background-image", "url(" + posts[i].post_image + ")");
        } else {
          // Display a placeholder image URL if post_image is not available
          $temp
            .find("[data-image-bg]")
            .css(
              "background-image",
              "url(" +
                "/wp-content/uploads/2023/09/Gown-and-Veil-scaled-1.jpg" +
                ")"
            );
        }

        var apostropheText = posts[i].post_excerpt.replace("&#8217;", "'");
        var spaceText = apostropheText.replace("&nbsp;", " ");

        $temp.find("[data-title-label]").text(posts[i].post_title);
        $temp.find("[data-excerpt]").text(spaceText);
        $temp.find("[data-date]").text(posts[i].post_date.split(" ")[0]);

        $temp.removeClass("hide");
        $temp.removeAttr("data-template");

        $(".inventory-listings-grid").append($temp);
      }

      // Build paginator
      $(".wf-inventory-list .pagination").removeClass("hide");

      $(".wf-inventory-list .pagination .page-numbers button").each(
        function () {
          $(this).remove();
        }
      );

      for (var ii = 1; ii <= pages; ii++) {
        var $buttonElem = '<button data-page="' + ii + '"';
        if (ii == page) {
          $buttonElem += ' class="current"';
        }
        $buttonElem += ">" + ii + "</button>";
        $(".wf-inventory-list .pagination .page-numbers").append($buttonElem);
      }

      // $('.wf-inventory-list .pagination .previous, .pagination .next').prop('disabled', false);

      if (page == pages) {
        $("#more_posts").prop("disabled", true).css("opacity", ".5");
      }

      $(".wf-inventory-list .pagination .page-numbers button").click(
        function () {
          updateFilterSort($(this).attr("data-page"), true);
        }
      );

      $(".wf-inventory-list .no-results").removeClass("show");
    } else {
      // $('.wf-inventory-list .pagination').addClass('hide');
      $(".wf-inventory-list .no-results").addClass("show");
    }
  }

  // run updateFilterSort() on page load
  updateFilterSort();

  if ($(window).width() <= 768) {
    $(".cat-dropdown").on("click", function () {
      $(".cat-list").fadeToggle();
    });
  }

  // AJAX LOAD MORE POSTS 2
  var isLoadMore = false;
  $("#more_posts").on("click", function () {
    isLoadMore = true;
    count++;
    updateFilterSort(count, true, isLoadMore);
  });



  //search 
  // function updateSearchResults(query) {
  //   // Clear previous search results
  //   $(".inventory-listings-grid .cell").addClass("hide");
    
  //   var hasResults = false; // Flag to check if there are matching results

  //   // Filter and display matching results
  //   $(".inventory-listings-grid .cell").each(function () {
  //       var title = $(this).find("[data-title-label]").text().toLowerCase();
  //       if (title.includes(query.toLowerCase())) {
  //           $(this).removeClass("hide");
  //           hasResults = true; // Set the flag to true if there are matching results
  //       }
  //   });

  //   // Display the "No Results" message if there are no matching results
  //   if (!hasResults) {
  //       $(".no-results").removeClass("hide");
  //   } else {
  //       $(".no-results").addClass("hide");
  //   }
  // }





  // Event listener for input changes
  $("#search-input").on("input", function () {
      var query = $(this).val();

      if (query !== '') {
        $('.single-blog').hide();

        $.ajax({
          url: "/wp-admin/admin-ajax.php",
          type: 'post',
          data: { action: 'data_fetch', keyword: query },
          success: function(data) {
            var blogData = JSON.parse(data);

            buildResults(blogData);

            $('.single-blog').show();
          }
        });

        // return;
      } else {
        updateFilterSort();
        $("#more_posts").prop("disabled", false);
        $("#more_posts").css('opacity', '1 !important');
      }

      
    
    
  });

  // set tags
  $('.single-blog-tags a').on('click', function() {
    var tag = $(this).attr('class');
    localStorage.setItem('tag', tag);
  });
}); 